import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Card, Row, Col, Form, FormGroup, Input, Label, Alert , Button } from 'reactstrap';
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";
import { Spinner } from 'react-bootstrap';
import { MdLock } from 'react-icons/md';

class ChangePasswordPage extends React.Component {

	constructor(props) {
        super(props);
        this.state = {
            loadPage: false,

            error: false,
            messageError: '',

            successForm: false,
            messageSuccessForm: '',

            errorForm: false,
            messageErrorForm: '',
            
            old_password: '',
            new_password: '',
            password_confirm: '',
            strengPass: 0,
        }
    }

    changeInput = (event) => {
        let name = event.target.name;   
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value    
        });
    }

    submit = () => {
    	let validate = this.validate();
    	if ( validate ) {

    		this.setState({
                loadPage: true
            });

	        let dataAuth = {
	            username: process.env.REACT_APP_CLIENT_ID,
	            password: process.env.REACT_APP_CLIENT_PASSWD,
	            token: process.env.REACT_APP_KEY,
	        }

	        let params = {
	        	old_password: this.state.old_password,
	        	new_password: this.state.new_password,
	        	password_confirm: this.state.password_confirm,
	        }

	        let config = {
	              headers: {
	                'Content-Type': 'application/json',
	                'Authorization' : this.props.token,
	                'dataAgency' : JSON.stringify(dataAuth)
	            }
	        }

            axios.post( process.env.REACT_APP_API_URL + '/api/home/change-password', params, config)
	        .then( (ref) => {
	            // console.log(ref.data);
	            this.setState({
	                loadPage: false,
	                error: false,
	                messageError: '',
	                errorForm: false,
		            messageErrorForm: '',
		            successForm: false,
	            	messageSuccessForm: '',
	            });
	            if ( ref.data.error === 0 ) {
	                this.setState({
	                    successForm: true,
		            	messageSuccessForm: ref.data.message,
		            	old_password: '',
			            new_password: '',
			            password_confirm: '',
			            strengPass: 0
	                });
	            } else {
	                if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
	                    this.props.logOut();
	                } else {
	                    this.setState({
	                        error: true,
	                        messageError: ref.data.message,
	                    })
	                }
	            }
	        })
	        .catch( (error) => {
	            console.log(error);
	            this.setState({
	                loadPage: false,
	                error: true,
	                messageError: 'Lấy dữ liệu thất bại'
	            })
	        })
        }
    }

    validate = () => {
    	this.setState({
            error: false,
            messageError: '',
            errorForm: false,
            messageErrorForm: '',
            successForm: false,
        	messageSuccessForm: '',
        });
        if ( this.state.old_password.length === 0 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Mật khẩu hiện tại không được để trống',
            });
            return false;
        }
        else if ( this.state.new_password.length === 0 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Mật khẩu mới không được để trống',
            });
            return false;
        }
        else if ( this.state.password_confirm.length === 0 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Nhập lại mật khẩu mới không được để trống',
            });
            return false;
        }
        else if ( this.passwordChanged( this.state.new_password ) < 75 ) {
            this.setState({
                error: true,
                messageError: 'Mật khẩu yếu. Mật khẩu phải có ký tự chữ số, chữ hoa, chữ thường và ký tự đặc biệt',
            })
            return false;
        }
        return true;
    }

    changePassword = (event) => {
        let name = event.target.name;
        let password = event.target.value;
        let strengPass = this.passwordChanged(password);
        this.setState({
            [name]: password,
            strengPass: strengPass
        });
    }
        
    //kiểm tra mật khẩu
    passwordChanged = (pass) => {
        var  symbolSize = 0, natLog, score;
        var format = /[`!@#$%^&*()_+\-=\\[\]{};':",.<>?~]/;

        if ( pass.match(/[0-9]/) ) {
            symbolSize +=20;
        }
        if ( pass.match(/[a-z]/) ) {
            symbolSize +=28;
        }
        if ( pass.match(/[A-Z]/) ) {
            symbolSize +=28;
        }
        if ( format.test(pass) ) {
            symbolSize +=35;
        }
        if ( pass.match(/[^a-zA-Z0-9]/) ) {
            symbolSize +=35;
        }

        natLog = Math.log( Math.pow(symbolSize, pass.length) );
        score = natLog / Math.LN2;
        if (score > 100) {
            return 100;
        }
        return parseInt(score);
    }

	render() {
		return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Đổi mật khẩu"} page={"Đổi mật khẩu"} icon={<MdLock className="breadcrumb-icon"/>} />
                            <Row>
                            	<Col sm={10} md={9} lg={6} xl={5} className="mx-auto mt-4">
	                            	{
	                    				this.state.error ? (
	                                        <Alert color="danger">
	                                            { this.state.messageError }
	                                        </Alert>
	                                    ) : (
	                                        <></>
	                                    )
	                				}
	                    			{
	                                    this.state.errorForm ? (
	                                        <Alert color="danger">
	                                            { this.state.messageErrorForm }
	                                        </Alert>
	                                    ) : (
	                                        <></>
	                                    )
	                                }
	                                {
	                                    this.state.successForm ? (
	                                        <Alert color="success">
                                                { this.state.messageSuccessForm }
                                            </Alert>
	                                    ) : (
	                                        <></>
	                                    )
	                                }
	                            	<Card body>
	                					<Form onSubmit={() => this.submit()}>
	                						<FormGroup>
	                                            <Label for={'old_password'}>{'Nhập mật khẩu hiện tại'}</Label>
	                                            <Input type="password" placeholder="Nhập mật khẩu hiện tại" id="old_password" name="old_password"  onChange={this.changeInput} value={this.state.old_password} />
	                                        </FormGroup>
	                                        <FormGroup>
	                                            <Label for={'new_password'}>{'Nhập mật khẩu mới'}</Label>
	                                            <Input type="password" placeholder="Nhập mật khẩu mới" id="new_password" name="new_password"  onChange={this.changePassword} value={this.state.new_password} />
	                                        	<div className="progress mt-1" id="passwordStrengthBar">
	                                                {
	                                                    this.state.strengPass > 75 ? (
	                                                        <div className="progress-bar progress-bar-success" role="progressbar"
	                                                             aria-valuenow={ this.state.strengPass } aria-valuemin="0" aria-valuemax="100"
	                                                             style={{ width: `${this.state.strengPass}%`}}
	                                                        >
	                                                            <span className="progress-text color-white text-center">Độ mạnh của mật khẩu: {this.state.strengPass}%</span>
	                                                        </div>
	                                                    ) : (
	                                                        <div
	                                                            className="progress-bar progress-bar-danger" role="progressbar"
	                                                            aria-valuenow={ this.state.strengPass } aria-valuemin="0" aria-valuemax="100"
	                                                            style={{ width: `${this.state.strengPass}%`}}
	                                                        >
	                                                            <span className="progress-text color-black text-center">Độ mạnh của mật khẩu: {this.state.strengPass}%</span>
	                                                        </div>
	                                                    )
	                                                }
	                                            </div>
	                                        </FormGroup> 
	                                        <FormGroup>
	                                            <Label for={'password_confirm'}>{'Nhập lại mật khẩu mới'}</Label>
	                                            <Input type="password" placeholder="Nhập lại mật khẩu mới" id="password_confirm" name="password_confirm"  onChange={this.changeInput} value={this.state.password_confirm} />
	                                        </FormGroup>
	                                        <hr />
	                                        <Button
	                                            size="lg"
	                                            className="bg-gradient-theme-left border-0"
	                                            block
	                                            onClick={() => this.submit()}
	                                            disabled={ this.state.btnDisable }
	                                        >
	                                            Đổi mật khẩu
	                                        </Button>
	                					</Form>
	                				</Card>
                        		</Col>
                            </Row>
                        </>
                    )
                }
            </>
        )
	}
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerChangePassword' }))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordPage);

